import React, {useEffect, useRef, useState} from "react";
import { Headings } from "@arctheme-components/elements/Headings/Headings";
import { ProductTile } from "@project-stories/ecommerce/Product/ProductTile";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import { mobileBreakpoint } from "../../../../entrypoints/theme";

export const StyleWith = ({ products = [], settings, style_products = [] }) => {

    const [selectedCategory, setSelectedCategory] = useState(style_products.length > 0 ? "styleProducts" : "recommendedProducts");
    const isMobile = useMobileBreakpoint(mobileBreakpoint);
    const carouselListRef:any = useRef(null);

    const handleCategoryClick = (category) => {
        setSelectedCategory(category);
    };


    useEffect(() => {
        const timeout = setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 2000);


        function resizeCarousel(){
            const carousels = document.querySelectorAll('.carousel')
            carousels.forEach((carousel) => {
                const flickityCarousel = window.Flickity?.data(carousel);

                if (flickityCarousel) {
                    setTimeout(() => {
                        flickityCarousel.resize();
                    }, 200);

                }
            });
        }
        window.addEventListener('carousel-init', () => {
            resizeCarousel();
        });
        resizeCarousel();
        // Clean up the timeout to prevent memory leaks
        return () => clearTimeout(timeout);
    }, []);

    settings.show_quickadd = settings.section.product_tile_quickadd_show;
    settings.show_price = settings.section.product_tile_price_show;
    settings.show_tags = settings.section.product_tile_tag_show;

    const renderProducts = (productList) => (
        <div
            className="recommendedproducts__container carousel flex-col w-full max-w-max"
            x-ref="carousel"
            x-data="carousel"

            ref={carouselListRef}
        >
                {productList.map((product, index) => (
                    <div key={index} className="carousel-item w-full lg:w-[262px] p-[70px] lg:p-[16px]"
                         x-init={
                             `$nextTick(() => { initialise(${settings.show_indicators},${settings.show_navbuttons},${settings.fade_edgeitems},false,false, 'stylewith', true, ${settings.use_freescroll}) })`
                         }
                    >
                        <ProductTile
                            product={product}
                            swatches={product.swatches}
                            siblings={undefined}
                            settings={settings}
                            enableWishlist={settings.section.product_tile_wishlist_show}
                        />
                    </div>
                ))}

        </div>
    );

    const renderStyleProducts = (productList) => (
        <>
            <div className="hidden lg:flex w-full justify-center">
                    {productList.map((product, index) => (
                        <div key={index} className="w-full lg:w-[262px] p-[70px] lg:p-[16px]">
                            <ProductTile
                                product={product}
                                swatches={product.swatches}
                                siblings={undefined}
                                settings={settings}
                                enableWishlist={settings.section.product_tile_wishlist_show}
                            />
                        </div>
                    ))}

            </div>
            <div
                className="recommendedproducts__container carousel flex-col w-full max-w-max lg:hidden"
                x-ref="carousel"
                x-data="carousel"

                ref={carouselListRef}
            >
                    {productList.map((product, index) => (
                        <div key={index} className="carousel-item w-full lg:w-[262px] p-[70px] lg:p-[16px]"
                            x-init={
                                `$nextTick(() => { initialise(${settings.show_indicators},${settings.show_navbuttons},${settings.fade_edgeitems},false,false, 'stylewith', true, ${settings.use_freescroll}) })`
                            }
                        >
                            <ProductTile
                                product={product}
                                swatches={product.swatches}
                                siblings={undefined}
                                settings={settings}
                            />
                        </div>
                    ))}

            </div>
        </>
    );

    let headingClass = "h3 cursor-pointer";

    if (isMobile) {
        headingClass = "h3";
    }

    return (
        <>
            {(products.length > 0 || style_products.length > 0) && (
                <div className="container recommendedproducts lg:px-[106px]">

                    <div className="recommendedproducts__header">
                        <div className="flex items-center mb-4 justify-center w-full">
                            {style_products.length > 0 && (
                                <div
                                    className={`basis-1/2 lg:basis-auto lg:px-[24px]`}
                                >
                                    <div
                                        className={`${headingClass} ${selectedCategory === "styleProducts" ? "selected text-black" : "text-gray-200"}`}
                                        onClick={() => handleCategoryClick("styleProducts")}
                                    >
                                        STYLE WITH
                                    </div>
                                </div>
                            )}
                            {products.length > 0 && (
                                <div
                                    className={
                                        "basis-1/2 lg:basis-auto lg:px-[24px] carousel-tab-header"
                                    }
                                >
                                    <div
                                        className={`${headingClass} ${selectedCategory === "recommendedProducts" ? "selected text-black" : "text-gray-200"}`}
                                        onClick={() => handleCategoryClick("recommendedProducts")}
                                    >
                                        RECOMMENDED
                                    </div>
                                </div>
                            )}
                            <div className="flex-1 border-b border-gray-300 hidden lg:hidden"></div>
                        </div>
                    </div>
                    {selectedCategory === "styleProducts" &&
                        style_products &&
                        renderStyleProducts(style_products)}
                    {selectedCategory === "recommendedProducts" &&
                        products &&
                        renderProducts(products)}
                </div>
            )}
        </>
    );
};

export default StyleWith;
